import {useEffect} from 'react'
import {useHistory} from 'react-router'

export const useSameHistoryListener = (callback: () => void) => {
	const history = useHistory()

	useEffect(() => {
		const histLocation = history.location
		const histHash = histLocation.hash
		const histSearch = histLocation.search
		const unlisten = history.listen((nextLocation, action) => {
			const search = nextLocation.search
			const hash = nextLocation.search
			const path = nextLocation.pathname
			const samePath = path === history.location.pathname
			const sameUrlParams = hash === histHash && search === histSearch
			const pushingLocation = action === 'PUSH'
			if (samePath && pushingLocation && sameUrlParams) {
				callback()
			}
		})
		return () => unlisten()
	})
}
